<template>
  <v-layout column fluid>
    <div style="color: grey;">
      Search contact by first name or last name and select the contact to
      procceed
    </div>
    <v-layout wrap>
      <v-text-field
        flat
        :prepend-icon="procceed ? '' : 'search'"
        label="First Name"
        v-model="firstname"
      ></v-text-field>
      <v-text-field
        flat
        :prepend-icon="procceed ? '' : 'search'"
        label="Last Name"
        class="ml-3"
        v-model="lastname"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn color="info" @click="clearSearch">Reset</v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    procceed: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    firstname: {
      handler: function(val) {
        this.$emit("firstname", val);
      }
    },
    lastname: {
      handler: function(val) {
        this.$emit("lastname", val);
      }
    }
  },
  data() {
    return {
      firstname: "",
      lastname: ""
    };
  },
  methods: {
    clearSearch: function() {
      this.firstname = "";
      this.lastname = "";
      this.$emit("clear");
    }
  }
};
</script>
